import React from 'react'

import { Container } from './styles'

function Footer() {
  return (
    <Container>
      Criado e pensado por
      <a
        href="https://ogabrielaraujo.com.br"
        target="_blank"
        rel="noopener noreferrer"
      >
        Gabriel Araujo
      </a>
    </Container>
  )
}

export default Footer
